'use client';
import { classNames } from '@lib/classNames/classNames';
import NextLink from 'next/link';

import { LinkProps } from './types';

export const Link = ({
  variant = 'medium',
  children,
  href,
  className,
  labelLink,
}: LinkProps) => {
  const isExternalLink = href.startsWith('http') || href.startsWith('//');

  return (
    <NextLink
      itemProp="url"
      href={href}
      aria-label={labelLink || ''}
      target={isExternalLink ? '_blank' : '_self'}
      className={classNames({
        cls: 'cursor-pointer',
        mods: {
          '': variant === 'default',
          'text-text-base-tertiary hover:text-status-accent text-sm':
            variant === 'small',
          'text-text-base-secondary hover:text-status-accent text-base':
            variant === 'medium',
          'text-text-base-primary hover:text-status-accent font-medium':
            variant === 'large',
        },
        additional: [className],
      })}
    >
      <span itemProp="name">{children}</span>
    </NextLink>
  );
};
